// Sales Dashboard — Sales vs Target gauge. Half-circle RadialBarChart showing
// achieved amount against a target, since Recharts has no built-in gauge type.
import * as React from "react";
import { RadialBar, RadialBarChart, PolarAngleAxis } from "recharts";

export interface GaugeChartProps {
  value: number;
  target: number;
  valueFormatter?: (v: number) => string;
}

export function GaugeChart({ value, target, valueFormatter }: GaugeChartProps) {
  const fmt = valueFormatter ?? ((v: number) => String(v));
  const pct = target > 0 ? Math.min(Math.max((value / target) * 100, 0), 100) : 0;
  const data = [{ name: "achieved", value: pct, fill: "hsl(var(--primary))" }];

  return (
    <div className="flex h-full w-full flex-col items-center justify-center">
      <RadialBarChart
        width={220}
        height={140}
        cx="50%"
        cy="100%"
        innerRadius="120%"
        outerRadius="200%"
        barSize={18}
        startAngle={180}
        endAngle={0}
        data={data}
      >
        <PolarAngleAxis type="number" domain={[0, 100]} angleAxisId={0} tick={false} />
        <RadialBar background dataKey="value" cornerRadius={9} angleAxisId={0} />
      </RadialBarChart>
      <div className="-mt-4 text-center">
        <div className="text-2xl font-semibold tabular-nums text-foreground">{pct.toFixed(0)}%</div>
        <div className="text-xs text-muted-foreground">
          {fmt(value)} of {fmt(target)}
        </div>
      </div>
    </div>
  );
}

export default GaugeChart;
